interface Store {
  baseUrlApi?: string | { value: string };
  lang?: string;
}

interface Params {
  token?: string;
  [key: string]: any;
}

export class API {
  protected store?: Store;
  protected params?: Params;
  protected id?: string | number;

  constructor(store?: Store, params?: Params, id?: string | number) {
    this.store = store;
    this.params = params;
    this.id = id;
  }

  // Public method to set parameters
  setParams(params: Params): void {
    this.params = { ...this.params, ...params };
  }

  // Public method to set token
  setToken(token: string): void {
    if (!this.params) {
      this.params = {};
    }
    this.params.token = token;
  }

  // Abstract: should be implemented in subclass
  generateUrl(): string {
    throw new Error('generateUrl() must be implemented in subclass');
  }

  async fetchData(opts: any = {}): Promise<any> {
    let baseUrl = '';
    if (this.store && this.store.baseUrlApi) {
      const val = this.store.baseUrlApi;
      if (typeof val === 'object' && val !== null && 'value' in val) {
        baseUrl = val.value;
      } else if (typeof val === 'string') {
        baseUrl = val;
      }
      if (typeof window === 'undefined' && !baseUrl.includes('http')) {
        baseUrl = 'http://localhost:8080' + baseUrl;
      } else if (!baseUrl.includes('http')) {
        baseUrl = window.location.origin + baseUrl;
      }
    }
    let url = baseUrl + this.generateUrl();
    const fetchOpts = this.params && this.params.token ? { ...opts, headers: { Authorization: `Bearer ${this.params.token}` } } : opts;
    try {
      return await $fetch(url, fetchOpts);
    } catch (error) {
      throw error;
    }
  }
}
